import {
  Checkbox,
  Popover,
  Typography,
  Button,
  Divider,
  Box,
  ListItemText,
  ListItemIcon,
  MenuItem,
  MenuList,
} from '@mui/material'

const ColumnFilterPopover = ({
  anchorEl,
  onClose,
  title,
  values = [],
  selectedValues = [],
  onChange,
  onClear,
}) => {
  const open = Boolean(anchorEl)

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ p: 2, minWidth: 240, maxHeight: 420 }}>
        <Typography variant="subtitle2" noWrap>
          {title}
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
      {/* ===== Scrollable Menu ===== */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <MenuList dense disablePadding sx={{ maxHeight: 320, overflowY: 'auto' }}>
          {values.map((item) => {
            const value =
              typeof item === 'object' ? item.value : item
            const label =
              typeof item === 'object' ? item.label : item

            return (
              <MenuItem
                key={value}
                onClick={() => onChange(value)}
                sx={{ px: 2, py: 0.75 }}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={selectedValues.includes(value)}
                    tabIndex={-1}
                    disableRipple
                    size="small"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={label || '(empty)'}
                  primaryTypographyProps={{ noWrap: true }}
                />
              </MenuItem>
            )
          })}
        </MenuList>
      </Box>

      <Divider />

      {/* ===== Footer (Fixed Clear Button) ===== */}
      <Box
        sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'flex-end' }}
      >
        <Button
          size="small"
          onClick={onClear}
          disabled={selectedValues.length === 0}
        >
          Clear
        </Button>
      </Box>
    </Popover>
  )
}

export default ColumnFilterPopover
